import React from "react";
import { useTableEmployeesHook } from "./table-employees-hooks";

type ContextTableEmployees = ReturnType<typeof useTableEmployeesHook>;
export const TableEmployeesContext =
  React.createContext<ContextTableEmployees | null>(null);

export function useContextTableEmployees() {
  const context = React.useContext(TableEmployeesContext);

  if (!context) {
    throw new Error(
      "useContextTableEmployees must be used within a ContextTableEmployeesProvider",
    );
  }

  return context;
}
